export enum CompanyGroup {
    EIG = 'EIG',
    EIG_CN = 'EIG_CN',
    EIG_EU = 'EIG_EU',
    BLU = 'BLU',
    FCS = 'FCS',
    PAT = 'PAT',
    ZED = 'ZED'
}
